import type { DocumentStructureFolderItem, Tables } from "../types";

/**
 * This function calculates the total size of all files within a document structure folder.
 * It recursively sums the sizes of files in the folder and its subfolders.
 * @param documentStructure
 * @returns
 */
export function getDocumentStructureFolderSize<T extends { file: Tables<"files"> }>(
	documentStructure: DocumentStructureFolderItem<T>,
): number {
	function getFilesSize(items: DocumentStructureFolderItem<T>["items"]): number {
		return items.reduce((total, item) => {
			if (item.type === "file") {
				return total + (item.file.size || 0);
			} else if (item.type === "folder") {
				return total + getFilesSize(item.items);
			}
			return total;
		}, 0);
	}

	return getFilesSize(documentStructure.items);
}
